/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-menu': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.113 17.706L26.438 28.03l1.655-1.654L17.767 16.05 28.093 5.725l-1.655-1.654-10.325 10.325L5.787 4.071 4.133 5.725l10.325 10.326L4.133 26.377l1.654 1.654 10.326-10.325z" _fill="#E42E16"/>'
  }
})
